import { useState } from 'react'
import { useAuth } from './useAuth'

type Plan = 'creator' | 'pro' | 'lifetime'

export const useCheckout = () => {
    const [loading, setLoading] = useState(false)
    const { user } = useAuth()

    const redirectToCheckout = async (plan: Plan) => {
        setLoading(true)

        try {
            const isLive = process.env.REACT_APP_DODO_ENVIRONMENT === 'live_mode';

            let baseUrl = '';
            if (plan === 'creator') {
                baseUrl = isLive
                    ? process.env.REACT_APP_DODO_PROD_CREATOR_CHECKOUT_URL!
                    : process.env.REACT_APP_DODO_TEST_CREATOR_CHECKOUT_URL!;
            } else if (plan === 'pro') {
                baseUrl = isLive
                    ? process.env.REACT_APP_DODO_PROD_PRO_CHECKOUT_URL!
                    : process.env.REACT_APP_DODO_TEST_PRO_CHECKOUT_URL!;
            } else {
                baseUrl = isLive
                    ? process.env.REACT_APP_DODO_PROD_LIFETIME_CHECKOUT_URL!
                    : process.env.REACT_APP_DODO_TEST_LIFETIME_CHECKOUT_URL!;
            }

            if (!baseUrl) {
                throw new Error(`Checkout URL for ${plan} not found in environment config`);
            }

            // Construct final URL with metadata and redirect values
            const checkoutUrl = new URL(baseUrl);

            // DodoPayments supports passing query params that get converted to metadata
            // We append them to the URL
            checkoutUrl.searchParams.append('customer_email', user?.email || '');
            checkoutUrl.searchParams.append('customer_name', 'Customer');

            // Add metadata fields (The webhook expects these)
            // Note: DodoPayments query param key for metadata is typically 'metadata[key]'
            checkoutUrl.searchParams.append('metadata[userId]', user?.id || '');
            checkoutUrl.searchParams.append('metadata[plan]', plan);
            checkoutUrl.searchParams.append('metadata[customerEmail]', user?.email || '');

            // Set return URL
            const returnUrl = `${window.location.origin}/dashboard?upgraded=true&plan=${plan}`;
            checkoutUrl.searchParams.append('return_url', returnUrl);

            console.log('Redirecting to direct checkout:', checkoutUrl.toString());
            window.location.href = checkoutUrl.toString();

        } catch (error) {
            console.error('Checkout error:', error);
            alert('Failed to initiate checkout. Please check your connection.');

        } finally {
            setLoading(false)
        }
    }

    return { redirectToCheckout, loading }
}

